/** Signals — edit view (delegates to the shared SignalForm). */
import { SignalForm } from "./_SignalForm";

export function SignalEdit() {
  return <SignalForm action="edit" />;
}

export default SignalEdit;
